<template>
    <div class="main container">
        <hint :toHeic="arvHeic" :toCommon="arvCommon"></hint>
        <left></left>
        <div class="right abs">
            <!-- 只有转换页需要 -->
            <section class="heic ofh">
                <!-- <router-link to="/transform" tag="p" active-class="current" class="fl cp ct first">常规格式转换</router-link>
                <router-link to="/heicTransform" tag="p" class="fl cp ct last">Heic转换jpg</router-link>-->
                <p class="fl cp ct first" :class="{current:!inHeic}" @click="ChanHeic(false)">常规格式转换</p>
                <p class="fl cp ct last" :class="{current:inHeic}" @click="ChanHeic(true)">Heic转换jpg</p>
                <!-- <img :src="imgUrl()" alt> -->
            </section>

            <section>
                <div class="upper cb ofh">
                    <div class="fl cp btn-add" style="margin-left:15px;" alt @click="addFile()"></div>
                    <div
                        class="fl cp btn-addFolder"
                        style="margin-left:5px;"
                        alt
                        @click="addFolder()"
                    ></div>
                    <div class="fr cp btn-remove" alt @click="removeAll()"></div>
                </div>
                <div class="lower white2 cb ofh">
                    <p class="wh238">
                        <el-checkbox v-model="checkAll"></el-checkbox>
                        <span class="fileName">文件名称</span>
                    </p>
                    <p class="wh140">文件格式</p>
                    <p class="wh154">输出文件格式</p>
                    <p class="wh141">转换状态</p>
                    <p class="wh179">进度</p>
                    <p class="wh179">操作</p>
                </div>
            </section>
            <!-- 两个页面不一样 -->
            <section class="before" v-show="!files.length">
                <div class="default_img abs cp ct" @click="addFile()">
                    <img src="img/gen/pic_zhanwuwenjian.png" alt>
                    <br>
                    <p class="hint1">暂无文件</p>
                    <div class="hint non">
                        <img src="img/gen/ico_tishi.png" alt>
                        非VIP用户可转换最大2M的文件，升级VIP用户无大小限制。
                    </div>
                </div>
            </section>

            <vue-scroll :ops="ops" v-show="files.length">
                <!-- 只要空就看不见 -->
                <section class="fileList" v-show="files.length">
                    <ul>
                        <li class="cb ofh" v-for="(file,index) in files" :key="index">
                            <p class="wh238 ellipsis">
                                <el-checkbox @change="selectFile(file)" v-model="file.checked"></el-checkbox>
                                <span class="fileName">{{file.name}}</span>
                            </p>
                            <p class="wh130">{{file.type}}</p>
                            <p class="wh154">
                                <select class="bd1 br4 fl cp" v-model="file.out_format" size="1">
                                    <option
                                        :value="format.id"
                                        v-for="format in out_format_options"
                                        :key="format.id"
                                    >{{format.name}}</option>
                                </select>
                            </p>
                            <p
                                class="wh141"
                                :class="{failColor : file.status == 2}"
                            >{{getStatusText(file.status)}}</p>
                            <p class="wh179">
                                <span v-if="file.status != 2">
                                    <progress-bar :percent="file.process"></progress-bar>
                                    {{file.process}}%
                                </span>
                                <span v-else>
                                    <span @click="retry(file)">
                                        <img
                                            class="retry_icon cp"
                                            src="img/gen/ico_chongxinzhuanghuan.png"
                                        >
                                    </span>
                                </span>
                            </p>
                            <div class="wh179 fc">
                                <div
                                    class="cp btn-item btn-item-openDir"
                                    alt
                                    @click="itemOpenDir(file)"
                                ></div>
                                <div class="cp btn-item btn-item-open" alt @click="itemOpen(file)"></div>
                                <div
                                    class="cp btn-item btn-item-remove"
                                    alt
                                    @click="removeFile(index)"
                                ></div>
                            </div>
                        </li>
                    </ul>
                </section>
            </vue-scroll>
        </div>
        <popup-tip ref="tip"></popup-tip>
        <keep-alive>
            <bottom
            v-show="files.length"
            action="transform"
            :emptyFiles="emptyFiles"
            @imageTransform="imageTransform"
            @receiveOutpath="receiveOutpath"
            @receiveOutFormat="receiveOutFormat"
            ></bottom>
        </keep-alive>
        
    </div>
</template>
<script>
import PopupTip from "../components/common/PopupTip";
import Hint from "../components/common/Hint";
import Left from "../components/common/Left";
import Bottom from "../components/common/Bottom";
import ProgressBar from "../components/common/ProgressBar";
import File from "../mixin/File.js";
import bus from "../mixin/eventBus.js";
import Drop from "../mixin/tui-dropper.js";

export default {
    name: "Transform",
    components: { Left, Bottom, ProgressBar, PopupTip, Hint },
    mixins: [File, Drop],
    mounted() {
        var _this = this;
        var dropArea = window.$('.before')[0];
        _this.AttchDropMulti(dropArea, function (files) {
            for (let i = 0; i < files.length; i++) {
                let file = files[i]; //页面初始，不需要判断重复
                let type = file.name.split(".").pop().toLowerCase() || "";
                if (_this.allowExt.indexOf(type) > -1) {
                    let obj = {
                        name: file.name,
                        path: file.path,
                        type: type,
                        out_format: _this.out_format,
                        size: file.size, //单位字节
                        status: 0,
                        process: 0, //进度
                        outPath: "", //输出路径
                        checked: true //是否选中
                    };
                    _this.files.push(obj); //加入转换列表
                } else {
                    if (1 === files.length) {
                        _this.$refs.tip.show({ content: '不支持的格式' });
                    }
                }
            }
        });
    },
    data: function () {
        return {
            ops: {
                bar: {
                    background: 'rgba(210, 210, 210, 1)',
                },
            },
            isVip: true,
            inHeic: false,
            outPath: "",
            files: [], //转换列表
            selectedFiles: [], //用户勾选的文件
            out_format_options: {
                1: { id: 1, name: 'png' },
                2: { id: 2, name: 'jpg' },
                3: { id: 3, name: 'bmp' },
                // 4: {id: 4, name: 'ico'},
                // 5: {id: 5, name: 'svg'},
            },
            out_format: 1,
            checkAll: false, //默认勾选
            emptyFiles: true,
            alerted: false,
        };
    },
    computed: {
        allowExt() {
            //heic 转换
            if (this.inHeic) {
                return ["heic"];
            } else {
                return ["jpg", "jpeg", "gif", "png"]
            }
        }
    },
    methods: {
        //全选
        selectAll: function () {
            // this.files.forEach(file => {
                // file.checked = this.checkAll;

                //勾选逻辑 换了 先注释
                // if(file.checked){
                //     this.selectedFiles.push(file);
                // }else{
                //     this.selectedFiles.splice(index);
                // }
            // });
        },
        //选择单个文件 勾选逻辑 换了 先注释
        selectFile: function () {
            // if (file.checked) {
            //     this.selectedFiles.push(file);
            // } else {
            //     let index = this.selectedFiles.findIndex(ele => ele.path === file.path);
            //     this.selectedFiles.splice(index, 1);
            // }
        },
        imgUrl() {
            let path = "img/gen/ico_vip";
            return this.inHeic ? path + "1.png" : path + "0.png";
        },
        ChanHeic(goHeic) {
            if (!this.files.length) {
                this.inHeic = goHeic;
            } else {
                if (goHeic && this.inHeic) return;
                if (!goHeic && !this.inHeic) return;
                window.picAction = goHeic ? 'heic' : 'common';
                window.tuiHint.show();
                //提示用户离开后会清空列表
            }
        },
        arvHeic() {
            this.inHeic = true;
            this.files = [];
        },
        arvCommon() {
            this.inHeic = false;
            this.files = [];
        },
        //获取输出格式
        receiveOutFormat: function (format) {
            this.out_format = format;
        },
        //获取outpath
        receiveOutpath: function (outPath) {
            this.outPath = outPath;
        },
        /**
         * 格式转换
         */
        imageTransform: function () {
            this.alerted = false;
            this.transform(this.files);
            //如果勾选文件则转换勾选文件
            // if (this.selectedFiles.length > 0) {
            //     this.transform(this.selectedFiles);
            // } else {
            //     this.transform(this.files);
            // }
        },
        //添加文件
        addFile: function () {
            let _that = this;
            this._btnClickFun(false, this.allowExt, function (files) {
                for (let i = 0; i < files.length; i++) {
                    let file = files[i];
                    if (!_that._inArray(file, _that.files, "path")) {
                        let type = file.name.split(".").pop().toLowerCase() || "";
                        if (_that.allowExt.indexOf(type) > -1) {
                            let obj = {
                                name: file.name,
                                path: file.path,
                                type: type,
                                out_format: _that.out_format,
                                size: file.size, //单位字节
                                status: 0,
                                process: 0, //进度
                                outPath: "", //输出路径
                                checked: true //是否选中
                            };
                            //加入转换列表
                            _that.files.push(obj);
                        } else {
                            if (1 === files.length) {
                                _that.$refs.tip.show({ content: '不支持的格式' });
                            }
                        }

                    }
                }
            });
        },
        //重新转换
        retry: function (file) {
            let files = [];
            files.push(file);
            this.transform(files);
        },
        /**
         * 转换
         */
        transform: function (files) {
            let _that = this;
            for (let i = 0; i < files.length; i++) {
                let file = files[i];
                if (!file.checked) continue;
                // if (file.status != 1) {
                file.process = 80;
                _that.setStatus(file, 0);
                this._transform(file, file.out_format);
                // }
            }
        },
        //单个转换
        _transform: function (file, outType) {
            let _that = this;
            let outPath = this.outPath + "\\" + file.name.split(".")[0] + "." + this.out_format_options[outType].name;
            window.magickImg.transform(file.path, outPath,
                function () {
                    //成功
                    file.process = 100;
                    file.outPath = outPath;
                    _that.setStatus(file, 1);
                    //写入缓存,执行转换
                    //_this.$storage.set('transform_files', _this.files);
                },
                function () {
                    _that.setStatus(file, 2);
                    if(!_that.alerted){
                        window.toastr.error('有文件转换失败了，貌似奴家也无能为力...');
                        _that.alerted = true;
                    }
                    
                    // window.console.error(e);
                    //_this.$storage.set('transform_files', _this.files);
                });
        },
        setStatus(file, status) {
            return file.status = status;
        },
        getStatusText(status) {
            let txt;
            switch (status) {
                case 0:
                    txt = "待转换";
                    break;
                case 1:
                    txt = "转换成功";
                    break;
                case 2:
                    txt = "转换失败";
                    break;
                default:
                    txt = "待转换";
                    break;
            }
            return txt;
        },
        /**
         * 添加文件夹
         */
        addFolder: function () {
            let _this = this;
            _this._btnClickFun(true, this.allowExt, function (folder) {
                let path = folder.path;
                window.fs.readdir(path, function (err, files) {
                    if (err) {
                        //读取是否出错
                        window.console.error(err);
                    } else {
                        let types = _this.allowExt;
                        for (let i = 0; i < files.length; i++) {
                            let file = files[i];
                            let type = file.split('.').pop().toLowerCase() || '';
                            if (types.indexOf(type) > -1) {
                                let stat = window.fs.statSync(path + '\\' + file);
                                let obj = {
                                    name: file,
                                    path: path + '\\' + file,
                                    type: type,
                                    out_format: _this.out_format,
                                    size: stat.size, //单位字节
                                    status: 0,
                                    process: 0, //进度
                                    outPath: "", //输出路径
                                    checked: true //是否选中
                                };
                                //加入转换列表
                                _this.files.push(obj);
                            }
                        }
                    }
                });
            });
        },
        /**
         * 清除
         */
        removeAll: function () {
            if (!this.files.length) return;
            this.$refs.tip.show({ content:'确定要清空列表吗？', confirmAction: 'removeAll' });
            let _that = this;
            bus.$off('removeAll').$on('removeAll', () => {
                _that.files = [];
                _that.checkAll = false;
            });
        },
        //打开文件所在文件夹
        itemOpenDir(v) {
            window.shell.showItemInFolder(v.path)
            //window.openDir(v.path.substr(0, v.path.indexOf(v.name)));
        },
        itemOpen(v) {
            window.openDir(v.path);
        },
        /**
         * 删除单个图片
         * */
        removeFile(k) {
            this.$refs.tip.show({ content:'确定要删除文件吗？', confirmAction: 'removeFile' });
            let _that = this;
            bus.$off('removeFile').$on('removeFile', () => {
                _that.files.splice(k, 1);
            });
        },
        /**
         * 验证数据是否在数组中存在(按属性验证)
         * @param data 验证数据
         * @param arr 被验证的数组
         * @param name 验证的属性
         * @returns {boolean}
         * @private
         */
        _inArray: function (data, arr, name) {
            for (let v of arr) {
                if (data[name] == v[name]) {
                    return true;
                }
            }
            return false;
        }
    },
    watch: {
        files: {
          handler: function () {
            if(!this.files.length){
                this.checkAll = false;
                return;
            }
            let i = 0;
            this.files.forEach(file => {
                if(file.checked){
                    i++;
                }
            });
            if(i == this.files.length){
                this.checkAll = true;
                this.emptyFiles = false;
            }else if(i == 0){
                this.checkAll = false;
                this.emptyFiles = true;
            }else{
                this.emptyFiles = false;
            }
            //仅仅只是做个标记，Left 组件要判断
            window.editorUrls = this.files;
          },
          deep: true,//深度监听
          immediate: true
        },
        out_format(value) {
            this.files.forEach(file => {
                file.out_format = value;
            })
        },
        checkAll(value){
            let i = 0;
            this.files.forEach(file => {
                file.checked = value;
                if(file.checked){
                    i++;
                }
            });
            if(i){
                this.emptyFiles = false;
            } else{
                this.emptyFiles = true;
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.before {
    height: 460px;
}
.wh238 {
    width: 238px;
}
.wh140 {
    width: 140px;
}
.fileList .wh130 {
    width: 130px;
    padding-left: 10px;
}
.wh141 {
    width: 141px;
}
p.wh141 {
    padding-left: 14px;
}
.wh154 {
    width: 154px;
}
.wh179 {
    width: 179px;
}
.right {
    left: 115px;
    right: 1px;
}
.heic {
    height: 42px;
    border-bottom: 1px solid #e2e5ec;
}
.heic p {
    width: 84px;
    height: 40px;
    line-height: 42px;
    font-size: 14px;
    color: #a5b8c8;
}
.heic p.current {
    color: #464851;
}
.heic .current {
    border-bottom: 2px solid #0090ff;
}
.heic .first {
    margin-left: 20px;
}
.heic .last {
    margin-left: 35px;
}
.heic img {
    margin-left: 4px;
    margin-top: 11px;
}
.lower {
    display: flex;
}
.upper,
.lower {
    border-bottom: 1px solid #e2e5ec;
}
.upper {
    height: 57px;
}
.upper img {
    margin-top: 11px;
}
.upper .first {
    margin-left: 17px;
}
.upper .last {
    margin-left: 5px;
}
.upper .fr {
    margin-right: 20px;
}
.lower {
    height: 41px;
    line-height: 40px;
}
.lower .white3 {
    width: 16px;
    height: 16px;
    margin-top: 12px;
    margin-left: 20px;
}
.lower p {
    padding-left: 10px;
    font-size: 12px;
    color: #464851;
    border-left: 1px solid #e2e5ec;
    box-sizing: border-box;
}
.lower p:nth-of-type(1) {
    border-left: none !important;
}
.fileName {
    margin-left: 10px;
}
.lower p.fl {
    padding-left: 7px;
    border-left: none;
}
.lower .last,
.lower .fourth {
    width: 169px;
}
.lower .third,
.lower .first {
    width: 131px;
}
.lower .second {
    width: 144px;
}
.last,
.fourth {
    width: 179px;
}
.third {
    width: 132px;
    padding-left: 10px;
}
.second {
    width: 144px;
}
.first {
    width: 142px;
    padding-left: 10px;
}
.last img {
    margin: 3px 5px 0px 7px;
}
.fourth .gray2 {
    width: 63%;
    height: 4px;
    margin-top: 20px;
    margin-right: 8px;
}
.fourth img {
    margin-left: 60px;
    margin-top: 2px;
}
li {
    height: 40px;
}
li .white3 {
    width: 16px;
    height: 16px;
    margin-top: 12px;
    margin-left: 20px;
}
p {
    line-height: 40px;
    font-size: 12px;
    color: #464851;
}
p.fl {
    padding-left: 7px;
}
/* 下拉菜单 */
.wh154 select {
    width: 71px;
    height: 25px;
    margin-top: 7px;
    margin-left: 8px;
    padding-left: 3px;
    color: #7a8c9c;
}
select:focus {
    outline: none;
}
/* 下拉菜单 */
.fileList {
    max-width: 1036px;
    max-height: 360px;
}
.fileList li {
    display: flex;
    padding-left: 10px;
}
.fileList li:nth-of-type(even) {
    background-color: #fdfdfd;
}
.failColor {
    color: #ff2020;
}
.default_img {
    width: 400px;
    top: 230px;
    left: 0px;
    right: 0px;
    margin: auto;
    padding-top: 50px;
    padding-bottom: 50px;
}
.default_img .hint1 {
    margin-top: 10px;
    font-size: 18px;
    color: #464851;
}
.default_img .hint {
    /* 非 vip 用户 */
    font-size: 12px;
    color: #949494;
}
.el-checkbox {
    margin-left: 10px;
    margin-right: 0px;
}
.fc {
    display: flex;
    align-items: center;
}
.retry_icon {
    margin-left: 50px;
    margin-top: 3px;
}
.btn-add {
    width: 110px;
    height: 36px;
    margin-top: 10px;
    background: url("../../public/img/trans/btn_tianjiaupian01.png") no-repeat;
}
.btn-add:hover {
    background: url("../../public/img/trans/btn_tianjiaupian02.png") no-repeat;
}
.btn-add:active {
    background: url("../../public/img/trans/btn_tianjiaupian03.png") no-repeat;
}
.btn-addFolder {
    width: 110px;
    height: 36px;
    margin-top: 10px;
    background: url("../../public/img/trans/btn_tinajiawenjianjia01.png")
        no-repeat;
}
.btn-addFolder:hover {
    background: url("../../public/img/trans/btn_tinajiawenjianjia02.png")
        no-repeat;
}
.btn-addFolder:active {
    background: url("../../public/img/trans/btn_tinajiawenjianjia03.png")
        no-repeat;
}
.btn-remove {
    width: 110px;
    height: 36px;
    margin-top: 10px;
    background: url("../../public/img/trans/btn_qingkongliebiao01.png")
        no-repeat;
}
.btn-remove:hover {
    background: url("../../public/img/trans/btn_qingkongliebiao02.png")
        no-repeat;
}
.btn-remove:active {
    background: url("../../public/img/trans/btn_qingkongliebiao03.png")
        no-repeat;
}
.btn-item {
    width: 34px;
    height: 34px;
    margin-right: 15px;
}
.btn-item-openDir {
    background: url("../../public/img/trans/btn_dakai01.png") no-repeat;
}
.btn-item-openDir:hover {
    background: url("../../public/img/trans/btn_dakai02.png") no-repeat;
}
.btn-item-openDir:active {
    background: url("../../public/img/trans/btn_dakai03.png") no-repeat;
}
.btn-item-open {
    background: url("../../public/img/trans/btn_sousuo01.png") no-repeat;
}
.btn-item-open:hover {
    background: url("../../public/img/trans/btn_sousuo02.png") no-repeat;
}
.btn-item-open:active {
    background: url("../../public/img/trans/btn_sousuo03.png") no-repeat;
}
.btn-item-remove {
    background: url("../../public/img/trans/btn_shanchu01.png") no-repeat;
}
.btn-item-remove:hover {
    background: url("../../public/img/trans/btn_shanchu02.png") no-repeat;
}
.btn-item-remove:active {
    background: url("../../public/img/trans/btn_shanchu03.png") no-repeat;
}
</style>
